import {Exception} from '../models/exception';

export abstract class ExceptionHandlerService {

  /**
   * Process the exception based on the evaluated {@link ExceptionHandlerService}. Triggers the abstract handle function first and then calls the optional callback.
   * @param httpError the http error.
   */
  process(httpError: any): void {
    const exception = new Exception(httpError);
    this.handle(exception);
  }

  /**
   * This method should contain the logic to handle exceptions based on their type.
   *
   * @param exception the {@link Exception} that contains all http error information.
   */
  protected abstract handle(exception: any): void;

  /**
   * This method determines whether this handler should be used.
   * Returns true if this handler should be used, false otherwise.
   */
  abstract isResponsible(error: any): boolean;
}
